module.exports = __webpack_public_path__ + "img/Board_Login.55536994.png";